var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocialX = function SvgSocialX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "social-x_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m5.91 7 20.085 26.722L5 57h8.025l16.618-18.425L43.49 57H59L38.102 29.196 58.122 7h-8.026L34.454 24.342 21.42 7z"
  })));
};
export { SvgSocialX as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNNS45MTA1IDdMMjUuOTk0OSAzMy43MjIxTDUgNTdIMTMuMDI1MkwyOS42NDI4IDM4LjU3NTVMNDMuNDkwNyA1N0g1OUwzOC4xMDIzIDI5LjE5NTdMNTguMTIxMiA3SDUwLjA5NkwzNC40NTQzIDI0LjM0MjRMMjEuNDE5OCA3SDUuOTEwNVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjwvc3ZnPg==";